const scrollBehavior = {
  name: "scroll-behavior",
  path: "scroll-behavior",
  title: "scroll-behavior",
  description: "Utilities for controlling the CSS scroll-behavior property.",
  value: {
    "scroll-behavior": {
      "scroll-auto": "auto",
      "scroll-smooth": "smooth"
    }
  },
  exampleData: [
    {
      title: "scroll-auto, scroll-smooth",
      description: "Set the scroll behavior of an element:",
      example: {
        code: `<div class="scroll-auto overflow-auto h-32">Auto scroll behavior</div>
<div class="scroll-smooth overflow-auto h-32">Smooth scroll behavior</div>`
      }
    }
  ],
  htmlData: [
    {
      title: "Scroll behavior",
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">scroll-auto</code> or <code class="text-color-gray-800 dark:text-color-white font-semibold">scroll-smooth</code> to control the scroll-behavior property of an element.
      </p>
      <div class="flex gap-8 items-center">
        <div class="scroll-auto overflow-auto h-32 w-full border rounded p-2">
          <div style="height: 200px;">Auto scroll behavior</div>
        </div>
        <div class="scroll-smooth overflow-auto h-32 w-full border rounded p-2">
          <div style="height: 200px;">Smooth scroll behavior</div>
        </div>
      </div>
      `
    }
  ]
};

export default scrollBehavior;
